import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const formatRange = (from, to) => ({
  from: from.format(DATE_TIME_FORMAT),
  to: to.format(DATE_TIME_FORMAT),
});

const endOfTodayOrEarlier = (date, reference) =>
  date.isAfter(reference, 'day') ? reference.endOf('day') : date.endOf('day');

export const getCommissionRange = (range, reference = dayjs()) => {
  // The API interprets its inclusive date boundaries in UTC.
  const utcReference = reference.utc();

  switch (range) {
    case 'yesterday':
      return formatRange(utcReference.subtract(1, 'day').startOf('day'), utcReference.subtract(1, 'day').endOf('day'));
    case 'today':
      return formatRange(utcReference.startOf('day'), utcReference.endOf('day'));
    case 'lastMonth':
      return formatRange(utcReference.subtract(1, 'month').startOf('month'), utcReference.subtract(1, 'month').endOf('month'));
    case 'thisMonth':
    default:
      return formatRange(utcReference.startOf('month'), endOfTodayOrEarlier(utcReference.endOf('month'), utcReference));
  }
};

export const getCommissionBreakdown = (response) => response?.app_markup_statistics?.breakdown || [];

export const summarizeCommission = (breakdown, appId) => {
  if (appId) {
    const app = breakdown.find((item) => item.app_id === appId);

    return {
      commission: app?.app_markup_usd || 0,
      transactions: app?.transactions_count || 0,
      clients: app?.client_count || 0,
    };
  }

  return breakdown.reduce(
    (summary, app) => ({
      commission: summary.commission + (app.app_markup_usd || 0),
      transactions: summary.transactions + (app.transactions_count || 0),
      clients: summary.clients + (app.client_count || 0),
    }),
    { commission: 0, transactions: 0, clients: 0 }
  );
};
